import { render, staticRenderFns } from "./ProfileAccountCreation.vue?vue&type=template&id=af4704ec&scoped=true&"
import script from "./ProfileAccountCreation.vue?vue&type=script&lang=js&"
export * from "./ProfileAccountCreation.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAccountCreation.vue?vue&type=style&index=0&id=af4704ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4704ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af4704ec')) {
      api.createRecord('af4704ec', component.options)
    } else {
      api.reload('af4704ec', component.options)
    }
    module.hot.accept("./ProfileAccountCreation.vue?vue&type=template&id=af4704ec&scoped=true&", function () {
      api.rerender('af4704ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/checklist/ProfileAccountCreation.vue"
export default component.exports